import { render } from "./Anchor.vue?vue&type=template&id=3c77ad27"
import script from "./Anchor.vue?vue&type=script&lang=ts"
export * from "./Anchor.vue?vue&type=script&lang=ts"
script.render = render

export default script